var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/search")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "acac-trainers",
    transform: "translate(-332.000000, -207.000000)",
    fill: "#2F3628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(319.000000, 194.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/mobile/search",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.94549836,0 C10.7816649,0 13.8909967,3.10938051 13.8909967,6.94549836 C13.8909967,8.55231391 13.3433222,10.0747233 12.3591789,11.2972024 L12.3238207,11.3395835 L14.7923429,13.7913355 C15.0270272,14.0244613 15.0642015,14.3812179 14.9031726,14.6534998 L14.854341,14.7255077 L14.795678,14.7923887 C14.5682619,15.0213251 14.219325,15.0644412 13.938321,14.9041964 L13.8635102,14.8554381 L13.7946249,14.7957237 L11.3205574,12.3377245 L11.279439,12.3728818 C10.1928431,13.2426726 8.86994927,13.7683183 7.46221996,13.8720225 L7.19731353,13.8865034 L6.94549836,13.8909967 C3.10958488,13.8909967 0,10.7814118 0,6.94549836 C0,5.24459691 0.615198383,3.62327178 1.73251846,2.35553308 C3.05251165,0.85753361 4.93945416,0 6.94549836,0 Z M6.94549836,1.41571075 C5.34718705,1.41571075 3.84664007,2.09768737 2.7946478,3.29154493 C1.90467403,4.30133095 1.41571075,5.59011484 1.41571075,6.94549836 C1.41571075,9.99953639 3.89146034,12.475286 6.94549836,12.475286 C9.9997845,12.475286 12.475286,9.99974572 12.475286,6.94549836 C12.475286,3.89125101 9.9997845,1.41571075 6.94549836,1.41571075 Z",
    id: "Stroke-1"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.ff5ec616.svg";
export { ForwardRef as ReactComponent };